import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { BdMedicalInstitutionType } from '@bindoc-projects/clinic-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';

export const AYS_MEDICAL_INSTITUTION_TYPES_CONDITION_ID =
  'medicalInstitutionType';

export const FilterConditionMedicalInstitutionTypeType: FilterConditionPluginSpecification<
  BdMedicalInstitutionType[],
  FilterConditionMedicalInstitutionTypeDto,
  BdMedicalInstitutionTypeCondition
> = {
  type: 'medicalInstitutionType',
  category: 'clinic',
  displayName: { de: 'Betriebsstätten-Typ' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionMedicalInstitutionTypeDto,
  ): FilterConditionMedicalInstitutionTypePlugin {
    return new FilterConditionMedicalInstitutionTypePlugin(
      (obj.includes ?? []) as BdMedicalInstitutionType[],
    );
  },
  fromCondition(
    jsonObj: BdMedicalInstitutionTypeCondition,
  ): FilterConditionMedicalInstitutionTypePlugin {
    return new FilterConditionMedicalInstitutionTypePlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionMedicalInstitutionTypePlugin {
    return new FilterConditionMedicalInstitutionTypePlugin([]);
  },
};

export class FilterConditionMedicalInstitutionTypePlugin extends FilterConditionPluginImpl<
  BdMedicalInstitutionType[],
  FilterConditionMedicalInstitutionTypeDto
> {
  public static override Specification =
    FilterConditionMedicalInstitutionTypeType;

  constructor(private includes: BdMedicalInstitutionType[]) {
    super(FilterConditionMedicalInstitutionTypeType.type);
  }

  override clone(): FilterConditionMedicalInstitutionTypePlugin {
    return new FilterConditionMedicalInstitutionTypePlugin([...this.includes]);
  }

  override equals(other: FilterConditionMedicalInstitutionTypePlugin): boolean {
    return (
      super.equals(other) && BdArrayUtil.equals(this.includes, other.includes)
    );
  }

  override validationToText(): string {
    if (this.includes.length === 0) {
      return 'Mindestens einen Betriebsstätten-Typ auswählen';
    } else {
      return '';
    }
  }

  override toCondition(): BdCondition {
    return new BdMedicalInstitutionTypeCondition(this.includes, []);
  }

  override toJSON(): FilterConditionMedicalInstitutionTypeDto {
    return {
      type: this.type,
      includes: this.includes,
    };
  }

  override toText(): string {
    return this.includes.length === 1
      ? 'ein Betriebsstätten-Typ'
      : `${this.includes.length} Betriebsstätten-Typen`;
  }

  override toValue(): BdMedicalInstitutionType[] {
    return this.includes
  }
}

class BdMedicalInstitutionTypeCondition extends BdContentCondition<BdMedicalInstitutionType> {
  constructor(
    includes: BdMedicalInstitutionType[],
    excludes: BdMedicalInstitutionType[],
  ) {
    super(AYS_MEDICAL_INSTITUTION_TYPES_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionMedicalInstitutionTypeDto {
  type: string;
  includes: string[];
}
